import styled from 'styled-components';

import { Link } from '@savgroup-front-common/core/atoms/link';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';

export const $ToastLink = styled(Link)`
  color: ${({ theme }) => theme.colors.primary};
  display: block;
  text-decoration: underline;
  font-weight: 700;
`;

export const $ToastLastUpdate = styled.p`
  color: ${({ theme }) => theme.colors.paragraphTextColor};
  ${fontStyle('xs')};
  margin: 0;

  display: flex;
  justify-content: space-between;
`;
